import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export const StatisticsCardContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: 10px 12px 10px 14px;
  border-radius: 1rem;
  border: 1px solid ${themeColor('divider.primary')};
  min-height: 70px;
  min-width: 250px;
  align-items: center;
  gap: 8px;
`;

export const IconArea = styled.div`
  box-sizing: border-box;
  display: flex;
  background-color: ${themeColor('brand.secondary')};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
`;

export const TextArea = styled.div`
  flex-direction: column;
  border-radius: 4px;
  align-items: center;
`;
